import React, { memo } from 'react';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { ReportSnapshot } from '../../../models';
import { REPORT_CURRENCIES } from '../../../constants';
import ReportSettingPIT from './ReportSettingPIT';
import { Icon } from '../../../components';
import { useFormatDateByLocale } from '../../../util/hooks/useFormatDateByLocale';

interface ReportSettingProps {
  reportSnapshot: ReportSnapshot;
}

function ReportSettingFiscalRollforward({
  reportSnapshot,
}: ReportSettingProps): JSX.Element {
  const {
    currency,
    asOfDate1,
    asOfDate2,
    fiscalStartMonthName,
  } = reportSnapshot;
  const formattedAsOfDate1 = useFormatDateByLocale(asOfDate1);
  const formattedAsOfDate2 = useFormatDateByLocale(asOfDate2);

  return (
    <>
      <Styled.ReportSettingItem hasSecondColumn={true} hasSecondRow={true}>
        <Icon name="calendar" />
        <GStyled.Text>Start Date</GStyled.Text>
        <GStyled.Text fontWeight="medium">
        <GStyled.Text fontWeight="medium">{formattedAsOfDate1}</GStyled.Text>
        </GStyled.Text>
        <GStyled.Text>Fiscal Start Month</GStyled.Text>
        <GStyled.Text fontWeight="medium">{fiscalStartMonthName}</GStyled.Text>
        <GStyled.Text>Rollforward through</GStyled.Text>
        <GStyled.Text fontWeight="medium">{formattedAsOfDate2}</GStyled.Text>
      </Styled.ReportSettingItem>
      <ReportSettingPIT reportSnapshot={reportSnapshot} />
      <Styled.ReportSettingItem>
        <Icon name="currency" />
        <GStyled.Text>Currency</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {REPORT_CURRENCIES[currency].label}
        </GStyled.Text>
      </Styled.ReportSettingItem>
    </>
  );
}

export default memo(ReportSettingFiscalRollforward);
